var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("update"),
      "isDialogActive": _vm.dialog,
      "rightDisabled": !_vm.validForm,
      "rightLoading": _vm.requestsLoading,
      "hideLeft": true,
      "width": '1200px',
      "height": '800px',
      "persistent": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "rightClick": function rightClick() {
        return _vm.update();
      }
    }
  }, [_vm.localEstimate ? _c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('drop-area-multi', {
    staticClass: "mb-4",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.requestsLoading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  }), _c('repair-estimate-form', {
    attrs: {
      "value": _vm.localEstimate,
      "disabled": _vm.requestsLoading,
      "showDate": ""
    }
  })], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }